import React from "react";
import { useRef } from 'react';
// import { useDrag, useDrop } from 'react-dnd';
import _ from 'lodash';
// const ITEM_TYPE = 'segment-card';

const style = {
  border: '1px dashed gray',
  padding: '0.5rem 1rem',
  marginBottom: '.5rem',
  backgroundColor: 'white',
  cursor: 'move',
};

const Segment = ({ segment_type, originalPageOrder, segment_id, index, data, order, moveCardUp, moveCardDown, totalLength }) => {


  return (
    <div className="col-span-12 card 2xl:col-span-12">
      <div style={{ ...style }} className="text-15 pt-2 pb-2 flex justify-between items-center">
        <div>Old Order - {originalPageOrder[segment_id]} New Order - {index + 1} {_.upperCase(segment_type)}</div>
        <div className="flex gap-4">
          {index !== 0 ?
            <div onClick={() => moveCardUp(index)} className="flex items-center cursor-pointer">
              <i className="ri-arrow-up-line mr-1"></i>
              Move Up
            </div> :
            null
          }
          {index !== totalLength - 1 ?
            <div onClick={() => moveCardDown(index)} className="flex items-center cursor-pointer">
              <i className="ri-arrow-down-line mr-1"></i>
              Move Down
            </div> :
            null
          }
        </div>
      </div>
    </div>
  );
};

export default Segment;
